<template>
  <section class="d-flex location-info-section">
    <div
      v-show="checkCookieByName('postalCode')"
      class="heading"
    >
      Your Postal Code: {{ checkCookieByName('postalCode') }}
    </div>
    <div
      v-show="checkCookieByName('currentLocation') && locationEnable && !checkCookieByName('setPostalCode')"
      class="heading"
    >
      Your current location enabled
    </div>
    <small
      v-show="!checkCookieByName('postalCode') && checkCookieByName('currentLocation')"
      class="sub-heading"
      @click="setCustomPostalCode"
    >Set Postal Code?</small>
    <small
      v-show="checkCookieByName('postalCode')"
      class="sub-heading"
      @click="setCustomPostalCode"
    >Set different Postal Code?</small>
    <br>
    <small
      v-show="!locationEnable || (locationEnable && checkCookieByName('setPostalCode'))"
      class="sub-heading"
      @click="getCurrentLocation"
    >Use Current Location?</small>

    <div
      v-show="!isProximity"
      class="postal-code-block postal-code-block--home"
    >
      <input
        id="postal-code-input"
        v-model="postalCode"
        type="text"
        placeholder="Postal Code"
      >
      <button
        id="postal-code-clear"
        @click="verifyPostalCode"
      >
        Set
      </button>

      <Cookie ref="cookie" />
      <GmapMap
        ref="map"
        :center="mapSettings.center"
        :zoom="mapSettings.zoom"
      />
    </div>
  </section>
</template>
<script>
    import Cookie from './Cookie.vue';

    export default {
        components: {
            Cookie
        },
        data() {
            return {
                postalCode: '',
                isProximity: false,
                locationEnable: false,
                useCurrentLocation: false,
                mapSettings: {
                    center: {lat: 49.895077, lng: -97.138451},
                    zoom: 10,
                },
            };
        },
        async mounted() {
            await this.$refs.map.$mapPromise.then(() => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
                } else {
                    this.checkCookies();
                    this.locationEnable = false;
                }
            });
        },
        methods: {
            getCurrentLocation() {
                if (navigator.geolocation) {
                    this.useCurrentLocation = true;
                    navigator.geolocation.getCurrentPosition(this.homeRenderPosition, this.customLocationError);
                } else {
                    this.alertMessage("Your browser doesn't support the location service", 'error')
                }
            },
            setCustomPostalCode() {
                this.postalCode = '';
                this.deleteCookies();
                this.$refs.cookie.setCookie('setPostalCode', true, 5000);
                this.isProximity = false;
            },
            async verifyPostalCode() {
                if (!!this.postalCode) {
                    let geocoder = new window.google.maps.Geocoder();
                    let zipCode = this.postalCode;
                    let latitude = '';
                    let longitude = '';
                    let zeroResult = '';
                    let city = '';
                    let stateFullName = '';
                    let stateShortName = '';
                    try {
                        await geocoder.geocode({address: zipCode}, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                latitude = results[0].geometry.location.lat();
                                longitude = results[0].geometry.location.lng();
                                for (let ac = 0; ac < results[0].address_components.length; ac++) {
                                    let component = results[0].address_components[ac];
                                    switch (component.types[0]) {
                                        case 'locality':
                                            city = component.long_name;
                                            break;
                                        case 'administrative_area_level_1':
                                            stateFullName = component.long_name;
                                            stateShortName = component.short_name;
                                            break;
                                    }
                                }
                            } else {
                                zeroResult = true;
                            }
                        });
                    } catch (e) {
                        zeroResult = true;
                    }

                    if (!!latitude && !!longitude) {
                        this.isProximity = true;
                        this.$refs.cookie.setCookie('latitude', latitude, 5000);
                        this.$refs.cookie.setCookie('longitude', longitude, 5000);
                        this.$refs.cookie.setCookie('city', city, 5000);
                        this.$refs.cookie.setCookie('fullStateName', stateFullName, 5000);
                        this.$refs.cookie.setCookie('shortStateName', stateShortName, 5000);
                        this.$refs.cookie.setCookie('postalCode', this.postalCode, 5000);
                        this.$refs.cookie.setCookie('setPostalCode', true, 5000);
                        location.reload();

                    } else if (!!zeroResult) {
                        this.alertMessage('Zero result against provided Postal Code', 'error');
                    }
                } else {
                    this.alertMessage('Please enter the Postal Code', 'error');
                }
            },
            alertMessage(message, type) {
                this.$toasted.show(message, {
                    type: type,
                    position: 'top-left',
                    duration: 5000
                });
            },
            showPosition(position) {
                if (!this.checkCookieByName('setPostalCode')) {
                    this.homeRenderPosition(position);
                }
                if(!!this.checkCookieByName('postalCode')) {
                    this.isProximity = true;
                }
            },
            async homeRenderPosition(position) {
                this.locationEnable = true;
                let getAddress = true;

                if (!!this.$refs.cookie.getCookie('latitude') && !!this.$refs.cookie.getCookie('longitude')) {
                    let cookieLatitude = this.$refs.cookie.getCookie('latitude');
                    let cookieLongitude = this.$refs.cookie.getCookie('longitude');
                    if (cookieLatitude == position.coords.latitude && cookieLongitude == position.coords.longitude) {
                        getAddress = false;
                    }
                }
                this.isProximity = true;

                this.$refs.cookie.setCookie('latitude', position.coords.latitude, 5000);
                this.$refs.cookie.setCookie('longitude', position.coords.longitude, 5000);
                this.$refs.cookie.deleteCookie('postalCode');
                this.$refs.cookie.deleteCookie('setPostalCode');
                this.$refs.cookie.setCookie('currentLocation', true, 5000);

                if (getAddress) {
                    let latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    // This is making the Geocode request
                    let geocoder = new window.google.maps.Geocoder();

                    await geocoder.geocode({'latLng': latlng}, (results, status) => {
                        if (status == google.maps.GeocoderStatus.OK) {
                            for (let ac = 0; ac < results[0].address_components.length; ac++) {
                                let component = results[0].address_components[ac];
                                switch (component.types[0]) {
                                    case 'locality':
                                        this.$refs.cookie.setCookie('city', component.long_name, 5000);
                                        break;
                                    case 'administrative_area_level_1':
                                        this.$refs.cookie.setCookie('fullStateName', component.long_name, 5000);
                                        this.$refs.cookie.setCookie('shortStateName', component.short_name, 5000);
                                        break;
                                }
                            }
                            // location.reload();
                        }
                    });
                }

                if (this.useCurrentLocation) {
                    this.useCurrentLocation = false;
                    location.reload();
                }
            },
            showError(error) {
                this.locationEnable = false;
                this.checkCookies();
            },
            customLocationError(error) {
                this.alertMessage('Your location is disabled please turn it on and reload the page', 'error')
            },
            deleteCookies() {
                this.$refs.cookie.deleteCookie('latitude');
                this.$refs.cookie.deleteCookie('longitude');
                this.$refs.cookie.deleteCookie('city');
                this.$refs.cookie.deleteCookie('fullStateName');
                this.$refs.cookie.deleteCookie('shortStateName');
                this.$refs.cookie.deleteCookie('postalCode');
                this.$refs.cookie.deleteCookie('currentLocation');
                this.$refs.cookie.deleteCookie('setPostalCode');
            },
            checkCookieByName(cname) {
                let name = cname + "=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            checkCookies() {
                if (!!this.$refs.cookie.getCookie('latitude') && !!this.$refs.cookie.getCookie('longitude')) {
                    this.isProximity = true;
                } else {
                    this.isProximity = false;
                    this.deleteCookies();
                }
            },
        },
    };
</script>
